import { computed, onMounted, ref } from "vue";
import { useWindowSize } from "@vueuse/core";
import { breakpoints } from "~/utils/breakpoints";

export const useSsrIsMobile = () =>
  useState<boolean>("ssr-is-mobile", () => {
    if (process.server) {
      // If a reverse-proxy/CDN strips or normalizes UA headers, SSR can't reliably detect mobile.
      // Persist a lightweight client hint cookie so refreshes render correctly on first paint.
      const deviceHint = useCookie<string | null>('ta_device').value;
      if (deviceHint === 'm') return true;
      if (deviceHint === 'd') return false;

      const headers = useRequestHeaders(["user-agent", "sec-ch-ua-mobile"]);
      const ua = headers["user-agent"] || "";
      const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
        ua
      );
      const chMobile =
        headers["sec-ch-ua-mobile"] && headers["sec-ch-ua-mobile"] !== "?0";
      return Boolean(uaMobile || chMobile);
    }
    return false;
  });

export const useDeviceWidth = () => {
  const ssrIsMobile = useSsrIsMobile();
  const hydrated = ref(false);
  const fallbackWidth = ssrIsMobile.value
    ? breakpoints.screen_mobile
    : breakpoints.screen_laptop + 1;
  const { width } = useWindowSize({ initialWidth: fallbackWidth });
  const renderWidth = computed(() =>
    hydrated.value ? width.value : fallbackWidth
  );

  onMounted(() => {
    hydrated.value = true;
  });

  return {
    renderWidth,
    width,
    hydrated,
    fallbackWidth,
    ssrIsMobile,
  };
};
